import { useCheckoutContext } from "context/checkout-context";
import "./index.scss";

export const CheckoutSubmit = () => {
  const { handleCheckout, disableSubmitPayment } = useCheckoutContext();

  return (
    <div className="checkout-submit">
      <button
        className="order-summary-submit"
        onClick={handleCheckout}
        disabled={disableSubmitPayment}
      >
        Submit Order
      </button>
      <p className="submit-transaction-info">Your transaction is secured.</p>
    </div>
  );
};
